const pluralize = (infinitive: string, count: number, plural?: string) => {
  if (count === 1) return infinitive;

  return plural || `${infinitive}s`;
};

export default pluralize;
